import axios from 'axios';
import router from '../routing/router';
import { ADD_NOTIFICATION } from '../state/mutation-types';
import {useMainStore} from "../state/store";
import {useNotificationsStore} from "../state/modules/notifications";


export function requestSuccess(config) {
    const store = useMainStore();
    config.headers['jobtoolz-revision'] = store.revision;

    return config;
}

export function requestError(error) {
    return Promise.reject(error);
}

export function responseSuccess(response) {
    checkRevision(response);

    return response;
}

export function responseErrorMessage(error) {
    switch (error.response.status) {
        case 400:
        case 422:
            const getUniqueMessages = function(data) {
                let uniqueMessages = new Set()
                if (data.error) {
                    uniqueMessages.add(data.error)
                } else if (data.message && !data.errors) {
                    uniqueMessages.add(data.message)
                }
                for (let attribute in data.errors) {
                    data.errors[attribute].forEach((m) => uniqueMessages.add(m));
                }
                return uniqueMessages
            }

            let messages = getUniqueMessages(error.response.data)
            let msg = ''
            let and = ''
            messages.forEach(m => {
                and = msg ? '\r\n' : '';
                msg += and + m;
            })

            return msg;

        default:
            return (
                error.response.data.message ||
                'Something went wrong while performing this request! 🤷‍♂️'
            );
    }
}

export function responseError(error) {
    const store = useMainStore();
    const notificationsStore = useNotificationsStore();

    if (!axios.isCancel(error)) {
        if (
            error.response.status &&
            (error.response.status === 419 || error.response.status === 403)
        ) {
            // Session timed out - CSRF is invalid, or forbidden. Let's simply refresh
            return location.reload();
        }

        // status indicates 2FA is enforced
        if (error.response.status && error.response.status === 499) {
            const routeName = '/require-two-factor';
            if (router.currentRoute.value.path != routeName) {
                return router.push(routeName);
            }
            return Promise.reject(error);
        }

        if (
            responseErrorMessage(error) &&
            !error.request.responseURL.includes('/bulk-applications') &&
            !error.request.responseURL.includes('/register') &&
            !error.request.responseURL.includes('/business-email')
        ) {
            notificationsStore[ADD_NOTIFICATION]({
                type: 'error',
                message: responseErrorMessage(error),
            });
        }
    }

    checkRevision(error.response);

    return Promise.reject(error);
}

function checkRevision(response) {
    const store = useMainStore();

    //Check when there is a revision update
    let version = response.headers['jobtoolz-revision'];

    if (version && store.revision !== parseInt(version)) {
        //Trigger update so users can update App
        store.setWrongRevision(true);
    }
}
